/* eslint-disable @atlaskit/design-system/no-unsafe-style-overrides */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css as cssUnbounded } from '@compiled/react';
import { useIntl } from 'react-intl-next';

import Button, { IconButton } from '@atlaskit/button/new';
import { jsx, css } from '@atlaskit/css';
import VideoStopOverlayIcon from '@atlaskit/icon/core/video-stop-overlay';
import { fg } from '@atlaskit/platform-feature-flags';
import { Inline, Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import messages from './messages';

type Props = {
	onCancel: () => void;
	autoFocus?: boolean;
};

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const escTextStylesUnbounded = cssUnbounded({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	padding: '3px',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginLeft: '5px',
});

// no tokens for 3px exist, so using raw values
const escTextStyles = css({
	borderRadius: token('border.radius.100'),
	color: token('color.text.subtle'),
	backgroundColor: token('color.background.neutral'),
	fontWeight: token('font.weight.regular'),
});

const codeMd = xcss({
	backgroundColor: 'color.background.neutral',
	borderRadius: 'border.radius',
	height: token('space.250'),
	lineHeight: token('space.250'),
	width: '27px',
	textAlign: 'center',
	fontSize: '11px',
	color: 'color.text.subtlest',
});

export const CancelEscButton = ({ onCancel, autoFocus }: Props) => {
	const { formatMessage } = useIntl();
	return fg('platform_editor_new_ai_palette') ? (
		<Inline space="space.100" alignBlock="center">
			<Box as="span" xcss={codeMd} key={'escape-command-text'}>
				{formatMessage(messages.labelEsc)}
			</Box>
			<IconButton
				label="video stop overlay icon"
				spacing="compact"
				icon={() => (
					<VideoStopOverlayIcon
						label={'video-stop-overlay-icon'}
						color={token('color.icon.information')}
					/>
				)}
				onClick={onCancel}
				autoFocus={autoFocus}
			/>
		</Inline>
	) : (
		<Button autoFocus={autoFocus} testId="cancel-esc-button" type="button" onClick={onCancel}>
			{formatMessage(messages.labelCancel)}
			{/* ignore use-primitives-text below as it affects focus and all styles inside and outside the button */}
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- Ignored via go/DSP-18766 */}
			<span css={[escTextStyles, escTextStylesUnbounded]}>{formatMessage(messages.labelEsc)}</span>
		</Button>
	);
};
